(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
(function(){
  function polishRepairCart(){
    var cart = document.querySelector('.jtr-cart--repair-only');
    if(!cart) return;
    var button = cart.querySelector('.cart__checkout-button');
    if(button){
      button.textContent = 'Submit repair booking';
      button.setAttribute('aria-label','Submit repair booking');
      button.title = 'Submit repair booking — no payment is taken for the repair estimate';
    }
    var headingText = cart.querySelector('.jtr-cart__heading p');
    if(headingText) headingText.textContent = 'Review your repair request before submitting it securely.';
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded',polishRepairCart);
  }else{
    polishRepairCart();
  }
  new MutationObserver(polishRepairCart).observe(document.body,{childList:true,subtree:true});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
